/*
 * Selleasy "Compre junto" CTA — free-shipping label swap.
 *
 * The "Aproveite e compre junto" widget on the PDP is the third-party Selleasy
 * app (rendered client-side into `.lb-widget-bl`, outside this repo). When the
 * kit total shown by Selleasy reaches the store's free-shipping threshold, this
 * rewrites the CTA button label from "Adicionar kit ao carrinho" to
 * "🚚 Adicionar kit — Frete grátis", and restores it when it drops back below.
 *
 * It reads the same threshold the theme already exposes on
 * <free-shipping-badge data-threshold-cents> and the same Selleasy total the
 * free-shipping badge reads (`.lb-bundle-cta-total-cont .lb-price-sale-price`,
 * an `lb-default-price` attribute in cents that already includes the main
 * product + every checked add-on). It re-applies on every Selleasy DOM change
 * so the label stays correct as the shopper checks/unchecks items.
 */
(function () {
  'use strict';

  var LABEL_FREESHIP = '🚚 Adicionar kit — Frete grátis'; // "🚚 Adicionar kit — Frete grátis"

  function getThresholdCents() {
    // Primary source: a global exposed by the product section — works on every
    // layout and for products below the badge's min-price (the badge element
    // isn't rendered for those, so it can't be relied on).
    if (typeof window.freeShippingThresholdCents === 'number' && !isNaN(window.freeShippingThresholdCents)) {
      return window.freeShippingThresholdCents;
    }
    // Fallback: read it off the free-shipping badge when that layout renders it.
    var badge = document.querySelector('free-shipping-badge[data-threshold-cents]');
    if (!badge) return NaN;
    return parseInt(badge.getAttribute('data-threshold-cents'), 10);
  }

  function getSelleasyTotalCents(wrapper) {
    var el = wrapper.querySelector('.lb-bundle-cta-total-cont .lb-price-sale-price[lb-default-price]');
    if (!el) return NaN;
    return parseInt(el.getAttribute('lb-default-price'), 10);
  }

  // The Selleasy CTA button has no class name we can rely on. Prefer a button we
  // already tagged (survives our own label rewrite, which drops the "carrinho"
  // keyword); otherwise match by the default label text. After Selleasy
  // re-renders it drops our tag and restores its own text, so text-matching
  // picks it up again.
  function findButton(wrapper) {
    var tagged = wrapper.querySelector('[data-fs-applied]');
    if (tagged && wrapper.contains(tagged)) return tagged;

    var nodes = wrapper.querySelectorAll('button, a, [role="button"]');
    for (var i = 0; i < nodes.length; i++) {
      var text = (nodes[i].textContent || '').trim().toLowerCase();
      if (text.indexOf('adicionar') !== -1 && text.indexOf('carrinho') !== -1) {
        return nodes[i];
      }
    }
    return null;
  }

  // Deepest leaf element that carries the label, so we rewrite only the text and
  // leave any icon/structure Selleasy renders inside the button intact.
  function labelLeaf(btn) {
    var best = null;
    var all = btn.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var node = all[i];
      if (node.children.length === 0 && node.textContent && node.textContent.trim()) {
        best = node;
      }
    }
    return best || btn;
  }

  function apply() {
    var wrapper = document.querySelector('.lb-widget-bl');
    if (!wrapper) return;

    var threshold = getThresholdCents();
    var total = getSelleasyTotalCents(wrapper);
    if (isNaN(threshold) || isNaN(total)) return;

    var btn = findButton(wrapper);
    if (!btn) return;

    var leaf = labelLeaf(btn);
    var current = (leaf.textContent || '').trim();

    if (total >= threshold) {
      if (current === LABEL_FREESHIP) return; // already applied — avoids observer loop
      if (!btn.hasAttribute('data-fs-orig')) btn.setAttribute('data-fs-orig', current);
      leaf.textContent = LABEL_FREESHIP;
      btn.setAttribute('data-fs-applied', '1');
    } else if (btn.getAttribute('data-fs-applied') === '1') {
      leaf.textContent = btn.getAttribute('data-fs-orig') || 'Adicionar kit ao carrinho';
      btn.removeAttribute('data-fs-applied');
      btn.removeAttribute('data-fs-orig');
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function boot() {
    // Observe the whole document rather than the widget node itself. Selleasy
    // injects (and can later replace) `.lb-widget-bl` and hydrates its price
    // custom elements asynchronously, so watching a single cached node misses
    // renders that happen before/after it's captured. apply() re-queries the
    // widget lazily, so a body-level observer keeps the label correct on the
    // first render and on every selection change — no click required to kick in.
    // attributeFilter scopes attribute watching to Selleasy's own attributes,
    // so our data-fs-* writes don't re-trigger the observer.
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['lb-default-price', 'lb-selected'],
    });

    // Safety net for async hydration that may settle without surfacing a
    // mutation we observe: re-check for a few seconds after load, then stop
    // (the observer handles all ongoing changes from then on).
    var tries = 0;
    var timer = setInterval(function () {
      apply();
      if (++tries >= 20) clearInterval(timer);
    }, 250);

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
